import { render } from "./editCurator.vue?vue&type=template&id=45d4ddc2&scoped=true"
import script from "./editCurator.vue?vue&type=script&lang=js"
export * from "./editCurator.vue?vue&type=script&lang=js"

import "./editCurator.vue?vue&type=style&index=0&id=45d4ddc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d4ddc2"]])

export default __exports__